import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { from, of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';

import { scopesFromToken } from './scopes';

export const scopeGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const expected: string[] = route.data.expectedScopes ?? [];

  return auth.isAuthenticated$.pipe(
    take(1),
    switchMap((isAuthenticated) =>
      isAuthenticated
        ? from(auth.getAccessTokenSilently()).pipe(
            map((token) => {
              const granted = scopesFromToken(token);
              return expected.every((scope) => granted.includes(scope));
            }),
            catchError(() => of(false)),
          )
        : of(false),
    ),
    map((allowed) => {
      if (!allowed) {
        router.navigate(['/login']);
      }
      return allowed;
    }),
  );
};
